import {getWithAuth} from '@/api'
import {DossierMerchantInfoModel} from '@/stores/profile/DossierMerchantInfo'

export const getDossierMerchantProfile = () =>
    getWithAuth<DossierMerchantInfoModel>('/oppapi/v1/merchant-info')
